import { render, staticRenderFns } from "./BillingCurrencySelector.yaml?vue&type=template&id=4821c720&component"
import script from "./BillingCurrencySelector.yaml?vue&type=script&lang=ts&component"
export * from "./BillingCurrencySelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports